import { render, staticRenderFns } from "./host-set-news.vue?vue&type=template&id=16a86573&scoped=true&"
import script from "./host-set-news.vue?vue&type=script&lang=js&"
export * from "./host-set-news.vue?vue&type=script&lang=js&"
import style0 from "./host-set-news.vue?vue&type=style&index=0&id=16a86573&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a86573",
  null
  
)

export default component.exports